<template>
  <!-- D+1资金流水 -->
  <div class="home-page-container">
    <el-card style="margin:0 0 10px 0">
      <mer-search :searchConfig="formConfig" :searchBar="searchBar"
        @search="searchList"
        @reset="resetList"
        @changeTime="(value,model)=>changeTime(value,'searchBar', 'createTime', 'createEndTime')"
        :loading="tableLoading">
        <template slot="handler">
          <!-- <el-button size="mini" @click="download" icon="el-icon-download">导出</el-button> -->
          <download-button :downloadApi="downloadDetailsApi" :queryParams="{ ...downloadParams }" @countPoint="$track.clickEvent('按钮：导出', 1634182530)"></download-button>
        </template>
      </mer-search>
    </el-card>
    <el-card>
      <mer-table :loading="tableLoading"
        :tableConfig="tableConfig"
        :tableData="tableData"
        :pagination="pagination"
        @SizeChange="handleSizeChange"
        @PageChange="pageChange">
        <template slot="handler" slot-scope="{row}">
          <!-- <el-button-group v-if="row.remitStatusStr === '成功' && row.paymentChannel === '银行转账'">
            <el-button size="mini" @click="showDetail(row)">查看回执单</el-button>
          </el-button-group> -->
          <el-dropdown
            v-if="row.remitStatusStr === '成功' && row.paymentChannel === '银行转账'"
            trigger="click"
            @command="openReceipt"
            placement="bottom">
            <el-button type="primary" size="mini" @click="showDetail(row)">
              查看回执单<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item, index) in receiptList" :key="index" :command="item">{{`电子回单${index + 1}`}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </mer-table>
    </el-card>
  </div>
</template>
<script>
import listPage from '@/mixins/listPage'
import queryMix from '@/views/finance/mixins/query';
import { receiptView, querySettlementMethodList } from '@/api/finance'
import { getList, downloadDetailsApi } from '@/api/finance/d1'
import dayjs from 'dayjs'

// 查询表单配置
let formConfig = [
  { label: '结算周期', type: 'select', modelName: 'settlementCycle', placeholder: '全部', selectOptions: [], define: true, selectLabel: 'desc', selectValue: 'code', clearable: false},
  { label: '交易状态', type: 'select', modelName: 'remitStatus', placeholder: '全部', selectOptions: [{name:'成功',code: 10}, {name:'失败',code: 20},{name:'处理中',code: 30}], define: true, selectLabel: 'name', selectValue: 'code' },
  { label: '交易时间', type: 'date', modelName: 'tradeTime', model: '', dateType: 'datetimerange', format: 'yyyy-MM-dd HH:mm:ss', clearable:false },
]
// 表格参数配置
let tableConfig = [
  { label: '生成时间', prop: 'createTime', fixed: 'left', width: 150 },  { label: '交易完成时间', prop: 'dealTime', fixed: 'left', width: 150 },
  { label: '结算周期', prop: 'businessCycleName', width: 136  },
  { label: '交易状态', prop: 'remitStatusStr' },
  { label: '交易金额(元)', prop: 'payable',width: 136 },
  { label: '对应订单号', prop: 'remitId',width: 136 },
  { label: '操作', slot: 'handler', fixed: 'right', width: 150 }
]
export default {
  name: 'finance_withdrawDetail',
  mixins:[ listPage, queryMix ],
  data(){
    return{
      downloadDetailsApi,
      tradeTime:'',
      formConfig,
      tableConfig: tableConfig,
      receiptList: []
    }
  },
  created(){
    this.initPage()
    this.queryEnum()
    this.$track.pageViewEvent('页面：D+1资金流水', '1634182527')
  },
  methods:{
    searchList () {
      this.$track.clickEvent('按钮：查询', 1634182528)
      this.search()
    },
    resetList () {
      this.$track.clickEvent('按钮：重置', 1634182529)
      this.reset(this.initQuery)
    },
    // useDownload () {
    //   this.$track.clickEvent('按钮：导出', 1634182530)
    // },
    initPage () {
      this.initQuery()
      this.initList(getList)
    },
    async queryEnum() {
      const { code, result } = await querySettlementMethodList({ onlyDayN: true })
      if (code !== 200) return
      formConfig[0].selectOptions = result
    },
    // 设置默认查询条件，暂无默认时间间隔
    initQuery () {
      this.tradeTime = ''
      this.initTime('tradeTime', 0, 'searchBar', true, 'createTime', 'createEndTime')
      const { tradeTime } = this
      const initObj = { tradeTime: [tradeTime, null] }
      this.setSearchConfig(initObj)
      this.searchBar = { ...this.searchBar, settlementCycle: '' }
    },
    download () {
      this.downloadFile(downloadDetailsApi,'资金明细')
    },
    // 获取table ||  特殊的请求或数据处理，可以覆写该方法
    async refresh () {
      this.tableLoading = true
      const data = { ...this.searchBar, ...this.pagination, ...this.$_otherParams}
      //对查询条件做一次缓存
      this.downloadParams = { ...this.searchBar,...this.$_otherParams }
      if (this.$_hasSum) {
        this.getSumInfo(data)
      }
      try{
        const { code, result: {records = [], total} } = await this.$_listApi(data)
        if(code !== 200) return
        this.tableData.records = records
        this.tableData.total = parseInt(total)
      }catch(err){
        console.log(err)
      }finally{
        this.tableLoading = false
      }
    },
    // 查看回执单
    async showDetail (row) {
      this.receiptList = []
      // D+1账户type为2
      let params = {
        transNumber: row.remitId,
        type: 2
      }
      try {
        const { code, result } = await receiptView(params)
        if (code !== 200) return
        this.receiptList = result.urlList
      } catch (error) {
        console.log(error)
      }
    },
    openReceipt (url) {
      var a = document.createElement("a")
      a.setAttribute("href", url)
      a.setAttribute("target", "_blank")
      a.setAttribute("id", "camnpr")
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click();
    },
    search () {
      if (dayjs(this.searchBar.createEndTime).valueOf() - dayjs(this.searchBar.createTime).valueOf() > 31 * 24 * 3600 * 1000) {
        return this.$message.warning('查询范围不能超过31天')
      }
      this.pagination.pageIndex = 1
      // this.pagination.pageSize = 10
      this.refresh()
    }
  }
}
</script>
<style lang="less" scoped>
.home-page-container{
  margin-top: 20px;
}
.total-wrapper{
  margin: 15px 0px;
  .total-item{
    margin-right: 10px;
  }
}
</style>